import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { HomepageService } from '../../../services/homepage.service';
import { Title } from '@angular/platform-browser';
import { NotifierService } from 'angular-notifier';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.css']
})
export class UnsubscribeComponent implements OnInit {
  uEmail: any;
  unsubscribeEmail: any;
  responseAPIstatus: boolean;
  unsubscribeResponse: any;
  unsubscribeShow: boolean;
  unsubscribeError: string;
  unsubsribeMsg:string ="";

  constructor(private activateRoute: ActivatedRoute, private homepageService: HomepageService, private notifier: NotifierService, private titleService:Title, @Inject(DOCUMENT) private document: Document) { 
    this.activateRoute.queryParams.subscribe((query: Params) => {
      this.uEmail= query['u'];
    });
  }

  ngOnInit() {
    this.titleService.setTitle('Unsubscribe');
    $('.loding-img-main').remove();
  }      

  unsubscribe(){
    this.homepageService.getUnsubscribeEmail(this.uEmail).subscribe((data:any)=>{
      this.responseAPIstatus = false;
      this.unsubscribeEmail = data.data;
      if(data.status){
        this.unsubsribeMsg= "Success";
        this.document.getElementById('unsubscribe_div').style.display='none';
        // this.notifier.notify( 'success', data.message);      
      } else {
        this.notifier.notify( 'error', data.message );
      }
    }, (error)=>{
      this.notifier.notify( 'error', 'Something went wrong!' );
    });
  }
}

